import React from 'react'
import { Button } from 'reactstrap'
import { sortCaret, IconeDelete, IconeEditar } from '../../../comum/components/Icones'
import { observable } from 'mobx'
import DirecionamentoRecintoService from '../../../../services/DirecionamentoRecintoService'
import { situacaoFormatter, formatFieldDate, formatContainers, formatarDataCustomHTML } from '../../../../utils/formatar';
import { buscaFiltrarVazio, buscaSemResultado } from '../../../../utils/mensagens';
import FileSaver from 'file-saver'
import moment from "moment";

export default class DirecionamentoRecintoStore {

    @observable operacao;
    @observable status;
    @observable ce;
    @observable container;
    @observable cnpj;
    @observable cliente;
    @observable tipoDoc;
    @observable flagCarga;


    @observable listaOperacoes;
    @observable listaStatus;

    @observable itens;
    @observable hasMore;
    @observable listaSelecionados;
    @observable listaAdicoes;
    @observable filtrado;

    @observable loadingOperacoes;
    @observable loadingDirec;
    @observable loadingSalvar;
    @observable tableMessage;
    @observable mensagem;
    @observable adicionando;
    @observable editando;
    @observable elementoEmEdicao;

    @observable modalAdicionarAnexo;
    @observable modalInativar;
    @observable modalAdicionar;
    @observable modalImportar;
    @observable listaDirecionamentos;

    @observable dadosAdicao;

    @observable msgCe;


    constructor() {

        //Filtros

        this.operacao = ""
        this.status = ""
        this.ce = ""
        this.container = ""
        this.cnpj = ""
        this.cliente = ""

        //Fim Filtros

        this.listaDirecionamentos = []
        this.listaSelecionados = []
        this.listaOperacoes = []
        this.listaAdicoes = []
        this.listaStatus = []
        this.operacoes = []
        this.enviados = []
        this.itens = []

        this.download = document.createElement('a')
        document.body.appendChild(this.download)
        this.download.style = "display: none"
        this.download.target = "_blank"

        this.idAdd = 0
        this.turn = 0
        this.toShow = 20

        this.colunas = this.todasColunas

        this.modalAdicionarAnexo = false
        this.loadingOperacoes = false
        this.modalAdicionar = false
        this.modalImportar = false
        this.modalInativar = false
        this.loadingSalvar = false
        this.loadingDirec = false
        this.adicionando = false
        this.filtrado = false
        this.editando = false
        this.hasMore = false

        this.elementoEmEdicao = null

        this.tableMessage = buscaFiltrarVazio
        this.mensagem = ""

        this.dadosAdicao = {
            tipoDoc: null,
            dtInicial: null,
            dtFim: null,
            operacao: null
        }

        this.service = new DirecionamentoRecintoService()

        this.outrosDados = [
            { titulo: "Arquivo Anexo", field: ["NomeArquivo"], id: "F1", hidden: false, download: true },
            { titulo: "Criado por", field: ["NomeImport", "DtImport"], formatacao: formatFieldDate, id: "F2", hidden: false },
            { titulo: "Inativado por", field: ["NomeCancel", "DtCancel"], formatacao: formatFieldDate, id: "F3", hidden: false },
            { titulo: "Container", field: ["Container"], formatacao: formatContainers, id: "F5", hidden: false }
        ];

        this.listarOperacoes()
        this.listarStatus()

        this.msgCe = "";

        this.flagCarga = false;

    }

    // Listagem de dados
    // Direcionamentos - Tabela contendo os dados
    listarDirecionamentos = () => {
        if(this.ce!== "" && this.ce.length < 15) {
            this.msgCe = "Por favor, insira todos os 15 digitos.";
            return;
        } else {
            this.msgCe = "";
        }
        this.tableMessage = ""
        this.loadingDirec = true
        this.filtrado = true
        this.service.RecintoConsultar(
            "",
            "",
            this.operacao ? this.operacao.value : "",
            this.status ? this.status.value : "",
            this.ce,
            this.container,
            this.cnpj,
            this.cliente
        ).then(response => {
            if (response && response.data) {
                this.listaDirecionamentos = response.data
                this.listaDirecionamentos.map(direc => {
                    direc.selecionado = false
                })

                if (this.listaDirecionamentos.length === 0) {
                    this.tableMessage = buscaSemResultado
                }

                this.loadFirstTurn()

            }
        }).catch(err => console.log(err)
        ).finally(() => { this.loadingDirec = false })
    }

    loadFirstTurn = () => {
        this.itens = this.listaDirecionamentos.slice(0, this.toShow)
        this.turn = 1
        this.hasMore = this.itens.length < this.listaDirecionamentos.length
    }

    loadNextTurn = () => {
        this.itens = []
        this.itens = this.listaDirecionamentos.slice(0, (this.turn + 1) * this.toShow)
        this.turn = this.turn + 1

        this.hasMore = this.itens.length < this.listaDirecionamentos.length
    }

    // Operações - Filtro de Operações
    listarOperacoes = () => {
        this.loadingOperacoes = true
        this.service.RecintoOperacoes().then(response => {
            if (response && response.data) {
                this.listaOperacoes = response.data.map(resp => ({ label: resp.NavioViagem + " - " + moment(resp.DtPrevAtrac).format("DD/MM/YYYY"), value: resp.CarrierVisitId }))
            }
        }).catch(err => console.log(err)
        ).finally(() => this.loadingOperacoes = false)
    }

    // Status - Filtro de Status
    listarStatus = () => {
        this.service.Status().then(response => {
            if (response && response.data) {
                this.listaStatus = response.data.map(resp => ({ label: resp, value: resp }))
            }
        }).catch(err => console.log(err))
    }

    // Clientes - Filtro de Clientes
    listarClientes = (value) => {
        this.cliente = value
    }
    // FIM da Listagem de dados

    // Métodos set para os filtros  
    setOperacao = (value) => {
        this.operacao = value
    }

    setStatus = (value) => {
        this.status = value
    }

    setCe = (value) => {
        this.msgCe = value !== "" && value.length < 15 ? "Por favor, insira todos os 15 digitos." : this.msgCe = "";
        this.ce = value
    }

    setTipoDoc = (value) =>{
        this.tipoDoc = value
    }

    setContainer = (value) => {
        this.container = value
    }

    setCnpj = (value) => {
        this.cnpj = value
    }

    setCliente = (value) => {
        this.cliente = value
    }

    setFlagCarga = (value) => {
        this.flagCarga = value;
    }
    
    // Fim dos métodos set


    // Modal
    abrirModalImportar = () => {
        this.modalImportar = true
    }

    abrirModalAdicionar = () => {
        this.modalAdicionar = true
    }

    fecharModalImportar = () => {
        this.modalImportar = false
    }

    fecharModalAdicionar = () => {
        this.modalAdicionar = false
    }

    abrirModalInativar = () => {
        this.modalInativar = true;
    }

    abrirAdicionarAnexo = (row) => {
        this.elementoEmEdicao = row
        this.modalAdicionarAnexo = true
    }

    fecharAdicionarAnexo = () => {
        this.elementoEmEdicao = null
        this.modalAdicionarAnexo = false
    }

    confirmarInativar = () => {
        const listaInativar = [];

        this.listaSelecionados.map((value, index) => {
            let item = { "CeHouse": value.CeHouse, "CarrierVisitId": value.CarrierVisitId, "UsuarioImport": value.UsuarioImport, "Cnpj": value.Cnpj }
            listaInativar[index] = item;
        })

        this.service.RecintoInativar(listaInativar).then(response => {
            if (response && response.data) {
                if (response.data.Sucesso === true) {
                    this.mensagem = `${listaInativar.length > 1
                        ? "Direcionamentos inativados"
                        : "Direcionamento inativado"} com sucesso`
                } else {
                    //TODO padronizar mensagens
                    if (response.data.MensagemErro) {
                        this.mensagem = response.data.MensagemErro
                    } else {
                        this.mensagem = `Não foi possível inativar ${listaInativar.length > 1
                            ? "os direcionamentos"
                            : "o direcionamento"}`
                    }
                }
            }
            // mensagem de sucesso e erro
        }).catch(err => console.log(err) //mensagem de erro
        ).finally(() => {
            this.modalInativar = false
            this.listarDirecionamentos()
        })
    };

    cancelaInativar = () => {
        this.modalInativar = false;
    };

    downloadArquivoAnexo = (ceRaId, nomeArquivo) => {
        this.service.RecintoDownloadDocumento(ceRaId).then((response) => {
            if (response && response.data) {
                const { file, filename } = response.data
                FileSaver.saveAs(file, filename)
            }
        }).catch(err => console.error(err))
    }

    fecharModalMensagem = () => {
        this.mensagem = ""
    }

    // Fim Modal


    // Selecionar

    selecionar = (direc) => {
        direc.selecionado = !direc.selecionado
        this.listaSelecionados = this.itens.filter(i => i.selecionado === true);
    }

    selecionarTodos = (checked) => {

        this.itens.map(item =>
            item.selecionado = checked
        )

        this.listaSelecionados = this.itens.filter(i => i.selecionado === true)

    }

    // Fim Selecionar

    // Adicionar

    setDadosEntrada = (tipoDoc, dtInicial, dtFinal, operacao) => {
        this.dadosAdicao = {
            tipoDoc: tipoDoc,
            dtInicial: dtInicial,
            dtFim: dtFinal,
            operacao: operacao
        }
    }

    anexarArquivo = (event) => {
        this.elementoEmEdicao.Anexo = null //considerando sempre que só existirá 1 anexo
        if (event.target.files) {
            this.elementoEmEdicao.Anexo = { file: event.target.files[0], name: event.target.files[0].name.replace(/[^a-zA-Z0-9\.]/g, "") }
        }
    }

    removerAnexo = () => {
        this.elementoEmEdicao.Anexo = null
    }

    adicionarListaAdicoes = (tipoDoc, flagCarga, ceHouse, container, cnpj, razaoSocial, operacao, listaAnexos) => {
        let integrar = false;

        if (this.listaAdicoes) {
            this.listaAdicoes = this.listaAdicoes.map(add => {
                let dado = {}
                if (add.Operacao === operacao
                    && add.TipoDoc === tipoDoc
                    && add.flagCarga === flagCarga
                    && add.CeHouse === ceHouse
                    && add.Cnpj === cnpj
                    && razaoSocial
                    && add.RazaoSocial === razaoSocial.toUpperCase()
                    && listaAnexos
                    && add.Anexo
                    && add.Anexo.name === listaAnexos[0].name) {
                    integrar = true;
                    dado.TipoDoc = add.TipoDoc
                    dado.flagCarga = add.flagCarga
                    dado.Operacao = add.Operacao
                    dado.IdAdd = add.IdAdd
                    dado.CeHouse = add.CeHouse
                    dado.Container = container ? add.Container + ", " + container.toUpperCase() : add.Container
                    dado.Cnpj = add.Cnpj
                    dado.RazaoSocial = add.RazaoSocial
                    dado.Anexo = listaAnexos && listaAnexos[0]
                } else {
                    dado = add
                }
                return dado
            })
        }

        if (!integrar) {
            this.listaAdicoes.push({
                IdAdd: this.idAdd,
                TipoDoc: tipoDoc,
                flagCarga: flagCarga,
                CeHouse: ceHouse,
                Container: container ? container.toUpperCase() : container,
                Cnpj: cnpj,
                RazaoSocial: razaoSocial ? razaoSocial.toUpperCase() : razaoSocial,
                Operacao: operacao,
                Anexo: listaAnexos && listaAnexos[0] // Considerando somente 1 anexo, caso exista uma lista de anexos isso precisa ser modificado
            })
            this.idAdd += 1
        }
    }

    salvarNovosDirecionamentos = () => {
        this.loadingSalvar = true
        let todasAdicoesTemAnexo = true

        // Antes de adicionar eu tenho que verificar se todos os direcionamentos que serão adicionados possuem arquivos ou não.
        // Se algum deles não tiver, uma mensagem é enviada ao usuário obrigando-o anexar algum arquivo e a operação é abortada.
        todasAdicoesTemAnexo = this.listaAdicoes.find(adicao => adicao.Anexo === undefined)
        if (todasAdicoesTemAnexo !== undefined) {
            this.mensagem = "Não é possível enviar direcionamentos sem anexo."
            this.loadingSalvar = false
            return
        }

        //Agora cada item poderá ser enviado
        Promise.all(
            this.listaAdicoes.map(adicao => {
                let arqv = new FormData()
                arqv.append('file', adicao.Anexo.file);
                // Isso verifica se em algum momento o item a ser enviado já foi enviado no passado desta mesma tabela, se sim, ele não será enviado de novo
                // Isso garante somente os itens não enviados no caso de algum erro de serem enviados.
                if (!(this.enviados.includes(adicao.IdAdd))) {
                    return this.service.RecintoInclusao(adicao.TipoDoc, adicao.flagCarga, adicao.CeHouse, adicao.Container, adicao.Cnpj, adicao.RazaoSocial, adicao.Operacao.value, arqv).then(response => {
                        if (response === "Verifique sua conexão" || (response && response.data && response.data.Sucesso === false)) {
                            this.mensagem = response.data ? response.data.MensagemErro : "Houve um erro na inclusão"
                            return Promise.reject()
                        } else {
                            // Caso seja enviado com sucesso o elemento terá seu id de adicionamento salvo na lista, para que em caso de erro não seja reenviado 
                            this.enviados.push(adicao.IdAdd)
                            return Promise.resolve()
                        }
                    })
                }
            })
        ).then(() => {
            this.listaAdicoes = []
            // Se todos os itens foram enviados, essa lista pode ser limpa
            this.enviados = []
            this.adicionando = false
            this.setDadosEntrada(null, null, null, null)
            this.mensagem = "Inclusão realizada com sucesso"
            //mensagem de sucesso
        }, () => {
            //this.mensagem = "Houve um erro na inclusão"
            //mensagem de erro
        }).catch(err => {
            console.log(err)
        }).finally(() => {
            this.loadingSalvar = false
            if (this.operacao || this.status || this.ce || this.container || this.cnpj || this.cliente) {
                this.listarDirecionamentos()
            }
        })

    }

    cancelarAdicao = () => {
        this.listaAdicoes = []
        // Deve se limpar essa lista também se houver uma desistência por parte do usuário.
        this.enviados = []
        this.adicionando = false

        this.setDadosEntrada(null, null, null, null)

    }

    removerAdicaoLista = (row) => {
        const data = this.listaAdicoes.find(add => add.IdAdd === row.IdAdd)
        const index = this.listaAdicoes.indexOf(data)
        this.listaAdicoes.splice(index, 1)

        if (this.listaAdicoes.length === 0) {
            this.setDadosEntrada(null, null, null, null)
        }
    }

    editarElementoListaAdicao = (row) => {
        this.elementoEmEdicao = row
        this.editando = true
        this.modalAdicionar = true
    }

    alterarDadosEdicao = (ceHouse, flagCarga, container, cnpj, razaoSocial, listaAnexos) => {
        this.listaAdicoes = this.listaAdicoes.map(add => {
            let dado = {}
            if (add.IdAdd === this.elementoEmEdicao.IdAdd) {
                dado.TipoDoc = add.TipoDoc
                dado.flagCarga = flagCarga
                dado.Operacao = add.Operacao
                dado.IdAdd = add.IdAdd
                dado.CeHouse = ceHouse
                dado.Container = container ? container.toUpperCase() : container
                dado.Cnpj = cnpj
                dado.RazaoSocial = razaoSocial ? razaoSocial.toUpperCase() : razaoSocial
                dado.Anexo = listaAnexos && listaAnexos[0]
            } else {
                dado = add
            }
            return dado
        })

    }

    fecharEdicao = () => {
        this.elementoEmEdicao = null
        this.editando = false
        this.modalAdicionar = false
    }

    mostrarTabelaAdicionar = () => {
        this.adicionando = true
    }

    fecharTabelaAdicionar = () => {
        this.adicionando = false
    }

    // Fim Adicionar

    // Botões

    renderAcao = (row) => {
        return (
            <Button className="btn-com-bordas-cinza px-2" onClick={() => this.editarElementoListaAdicao(row)}>
                Editar
            </Button>
        )
    }

    renderExcluir = (row) => {
        return (
            <IconeDelete tamanho="2x" onClick={() => this.removerAdicaoLista(row)} />
        )
    }

    renderAnexoBotao = (cell, row) => {
        if (!row.Anexo) {
            return (
                <Button className="btn-com-bordas-primary px-2" onClick={() => this.abrirAdicionarAnexo(row)}>Anexar</Button>
            )
        } else {
            return <div onClick={() => this.abrirAdicionarAnexo(row)}>
                {row.Anexo.name}
                <IconeEditar tamanho="sm" className="ml-2" />
            </div>
        }
    }

    // Fim Botões


    todasColunas = [
        {
            text: "Navio/Viagem",
            dataField: "NavioViagem",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Data de Atracação",
            dataField: "Ata",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        },
        {
            text: "CE",
            dataField: "CeHouse",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Tipo de Documento",
            dataField: "TipoDocumento",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        
        {
            text: "CNPJ",
            dataField: "Cnpj",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Razão social",
            dataField: "RazaoSocial",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Booking",
            dataField: "BookingSaida",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Situação",
            dataField: "Status",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        },
    ]

    colunasAdicionar = [
        {
            text: "CE House",
            dataField: "CeHouse",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Tipo de Documento",
            dataField: "TipoDoc",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },

        {
            text: "Container",
            dataField: "Container",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "CPF/CNPJ",
            dataField: "Cnpj",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Razão Social",
            dataField: "RazaoSocial",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Anexo",
            dataField: "Anexo.name", //Dá um jeito nisso depois
            sort: true,
            formatter: (cell, row) => this.renderAnexoBotao(cell, row),
            typeButton: "Editar",
            buttonOnclick: this.abrirAdicionarAnexo,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Ação",
            dataField: "acao",
            sort: true,
            headerAlign: () => "center",
            align: 'center',
            sortCaret: sortCaret,
            typeButton: "Editar",
            buttonOnclick: this.editarElementoListaAdicao,
            formatter: (cell, row) => this.renderAcao(row)
            // Adicionar o formater para os botões
        },
        {
            text: "Excluir",
            dataField: "excluir",
            sort: true,
            headerAlign: () => "center",
            align: 'center',
            sortCaret: sortCaret,
            typeButton: "Excluir",
            buttonOnclick: this.removerAdicaoLista,
            formatter: (cell, row) => this.renderExcluir(row)
            // Adicionar o formater para os botões
        },
    ]

    colunasExportar = [
        {
            text: "Navio/Viagem",
            dataField: "NavioViagem",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "CE",
            dataField: "CeHouse",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Tipo de Documento",
            dataField: "TipoDocumento",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "CNPJ",
            dataField: "Cnpj",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Booking",
            dataField: "BookingSaida",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Razão social",
            dataField: "RazaoSocial",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Situação",
            dataField: "Status",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        },
        {
            text: "Criado por",
            dataField: "NomeImport",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        },
        {
            text: "Data Criação",
            dataField: "DtImport",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        },
        {
            text: "Inativado por",
            dataField: "NomeCancel",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        },
        {
            text: "Data Inativação",
            dataField: "DtCancel",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        },
        {
            text: "Containers",
            dataField: "Container",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        }
    ]
}


// WEBPACK FOOTER //
// ./src/modules/direcionamento/recinto/stores/DirecionamentoRecintoStore.js